import React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../../theme';
import { CdnIcon } from '@shared/ui';
import { IconButton } from '../../../../../../BaseComponents/Button';
import { openFileInNewTab, useFileUpload } from '@shared/lib/file-upload';
import { UploadedFile } from '@shared/ui/file-upload/UploadedFile';
import { useTranslation } from 'react-i18next';
import { MAX_FILE_SIZE_MB, STRING_SUPPORTED_FILE_MIME, STRING_SUPPORTED_FILE_TYPES } from '@shared/model/file-upload';
const AttachFile = ({ files, title, description, onChange, onDelete }) => {
    const { t } = useTranslation();
    const { AttachFile: css } = useTheme('Shared').FileUpload;
    const { inputRef, onChangeHandler, onClickHandler } = useFileUpload({
        files,
        onChange
    });
    const separator = !!description ? ':' : '';
    const selected = !!(files === null || files === void 0 ? void 0 : files.length);
    return (React.createElement("div", { className: cn(css.root, { [css.selected]: selected }) },
        React.createElement("input", { ref: inputRef, type: "file", accept: STRING_SUPPORTED_FILE_MIME, name: 'file', onChange: onChangeHandler, hidden: true, multiple: true }),
        React.createElement("div", { className: css.leftBlock },
            selected && React.createElement(CdnIcon, { className: css.includedIcon, icon: "Info/Item Icluded" }),
            React.createElement("div", { className: css.fileBlock },
                React.createElement("div", { className: css.infoBlock },
                    !!title && (React.createElement("span", { className: css.title },
                        title,
                        separator)),
                    !!description && React.createElement("span", { className: css.description }, description)),
                selected && (React.createElement("div", { className: css.files }, files.map(file => (React.createElement(UploadedFile, { key: file.id, name: file.file.name, error: t(file.error, {
                        types: STRING_SUPPORTED_FILE_TYPES,
                        size: MAX_FILE_SIZE_MB
                    }), onClick: () => openFileInNewTab(file.file), onDelete: () => onDelete(file.id) }))))))),
        React.createElement(IconButton, { classes: {
                root: css.iconButton
            }, onClick: onClickHandler },
            React.createElement(CdnIcon, { icon: 'Action/Attach file' }))));
};
export default AttachFile;
